import { defineMessages } from 'react-intl-next';

export const messages: {
    resultLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	resultLabel: {
		id: 'dynamic-cards-search-page.github-branch-result.label',
		defaultMessage: 'Branch',
		description: 'GitHub branch label shown as part of the metadata below the branch title in the search results, for example "Branch • frontend-repository • Updated 2 hours ago"',
	}
});
